import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';
import { AFRR_MARKET_TYPES } from '../../constants';
import _ from 'lodash';

const validateNumber = () => yup.number().typeError(ERRORS.number).required(ERRORS.required);

const capacityValidate = (approvalCapacity, market) => {
    if (AFRR_MARKET_TYPES.includes(market)) {
        return yup
            .number()
            .max(approvalCapacity, 'Capacity should be less than or equal to approved capacity')
            .typeError(ERRORS.number)
            .required(ERRORS.required)
            .test('multiple of 1', 'Capacity should be multiple of 1', (val) => Number.isInteger(val));
    } else {
        return yup.number().max(approvalCapacity, 'Capacity should be less than or equal to approved capacity').typeError(ERRORS.number).required(ERRORS.required);
    }
};

const validatePrice = () => {
    return yup
        .number()
        .required(ERRORS.required)
        .min(0)
        .test('price', 'Price should be greater than 0', (val, c) => {
            const idx = _.get(c, ['options', 'index']);
            const currIdxCap = _.get(c, ['from', 0, 'value', 'capacity', idx], 0);
            if (currIdxCap > 0 && val <= 0) {
                return false;
            } else if (currIdxCap <= 0 && val !== 0) {
                const { path, createError } = c;
                return createError({
                    path,
                    message: 'Price should be 0',
                });
            } else {
                return true;
            }
        });
};

export const editBidValidation = (approvalCapacity, market) => {
    return yup.object().shape({
        capacity: yup.array().of(capacityValidate(approvalCapacity, market)),
        price: yup.array().of(validatePrice()),
        ...(AFRR_MARKET_TYPES.includes(market) ? { regulationPrice: yup.array().of(validatePrice()) } : { reserveBidIdentification: yup.string().required(ERRORS.required) }),
        isExternal: yup.boolean().required(ERRORS.required),
    });
};

export const updateRegulationPrice = () => {
    return yup.object().shape({
        regulationPrice: yup.array().of(yup.number().min(0).required(ERRORS.required)),
    });
};
